import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgYodel({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7 12.03a2.651 2.651 0 012.654-2.655 2.651 2.651 0 012.655 2.655 2.651 2.651 0 01-2.655 2.655 2.651 2.651 0 01-2.655-2.655zm-2.196.69L2 9.517h1.398l.744 2.017.76-2.017h1.381L4.796 12.72v1.823H3.504V12.72zm7.753-3.203h1.646c.566 0 1.575 0 2.23.938.354.477.46 1.008.46 1.557 0 1.38-.673 2.531-2.584 2.531h-1.752V9.517zm1.805 3.893h-.531v-2.778h.549c.566 0 .832.23.973.46.195.3.248.655.248.938 0 .708-.283 1.38-1.24 1.38zm2.832-3.893h2.85v1.132h-1.558v.78h1.522v1.132h-1.522v.867h1.557v1.133h-2.85V9.517zm4.495 0h-1.292v5.026h2.78V13.41h-1.488V9.517zM9.86 12.03c0 .832-.673 1.504-1.505 1.504A1.503 1.503 0 016.85 12.03a1.503 1.503 0 113.009 0z"
        fill="#9C0"
      />
    </svg>
  )
}

export default SvgYodel
